var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-switch',{attrs:{"value":_vm.local_value.active,"loading":_vm.is_loading},on:{"input":_vm.change_status}})}
var staticRenderFns = []

export { render, staticRenderFns }